@if (resAsync | async) {
  <div #selectorContainer class="featureSelector">
    <button mat-icon-button class="buttonCancelfeature" (click)="cancel()">
      <mat-icon [svgIcon]="res.svgName('Close-Image')"></mat-icon>
    </button>
    <p class="helpText">{{ this.getHelpText() }}</p>
    <button (click)="close()" [disabled]="!isGeometryValid" class="buttonReady">
      {{ res.get('Done') }}
    </button>
  </div>
}
